import React, { useEffect, useState } from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import {
  Bars3Icon,
  ChevronDownIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useLocation, Link } from "react-router-dom";

import defaultLogo from "../../assets/img/logo.png";
import logokemenag from "../../assets/img/logo-kemenag.png";
import logoDiajeng from "assets/img/logoDiajeng.png";

import axios from "axios";
import { toast } from "react-toastify";

const navigation = [
  {
    name: "Beranda",
    href: "/",
    current: false,
  },

  {
    name: "Berita",
    href: "/berita",
    current: false,
  },

  {
    name: "Artikel",
    href: "/artikel",
    current: false,
  },

  {
    name: "Profil",
    href: "",
    current: false,
    submenu: [
      {
        name: "Visi Misi",
        href: "/visimisi",
      },
      {
        name: "Sambutan",
        href: "/sambutan",
      },
    ],
  },

  {
    name: "Galeri",
    href: "",
    current: false,
    submenu: [
      {
        name: "Foto",
        href: "/foto",
      },
    ],
  },

  {
    name: "Fitur",

    // Menu Fitur menuju section FiturDiajeng
    href: "/#fitur",

    current: false,
  },
  {
    name: "Pengumuman",
    href: "",
    current: false,
    submenu: [
      {
        name: "ASTS",
        href: "/asts",
      },
    ],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header({
  isInsideHero = false,
  className = "",
}) {
  const location = useLocation();

  const [logos, setLogos] = useState([]);

  const [isScrolled, setIsScrolled] = useState(false);

  const updatedNavigation = navigation.map((item) => ({
    ...item,

    current:
      item.href === location.pathname ||
      (item.name === "Fitur" &&
        location.pathname === "/" &&
        window.location.hash === "#fitur"),
  }));

  /*
  |--------------------------------------------------------------------------
  | Scroll Navbar
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /*
  |--------------------------------------------------------------------------
  | Fetch Logo
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    const fetchLogoData = async () => {
      try {
        const response = await axios.get("/api_w/logo", {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        const logoData = response.data?.data || [];

        // Default logo
        const defaultLogos = [
          {
            id: 1,
            url: defaultLogo,
          },
          {
            id: 2,
            url: logokemenag,
          },
        ];

        // Gunakan logo dari API jika tersedia
        const logosDefaults = defaultLogos.map(
          (defaultLogoItem) => {
            const found = logoData.find(
              (logo) => logo?.id === defaultLogoItem.id
            );

            return found || defaultLogoItem;
          }
        );

        setLogos(logosDefaults);
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            error.message ||
            "Gagal memuat logo"
        );

        setLogos([
          {
            id: 1,
            url: defaultLogo,
          },
          {
            id: 2,
            url: logokemenag,
          },
        ]);
      }
    };

    fetchLogoData();
  }, []);

  const isHomePage = location.pathname === "/";

  return (
    <div>
      <Disclosure
        as="nav"
        className={`
          ${
            isInsideHero && !isScrolled
              ? "absolute"
              : "fixed"
          }

          top-0
          z-50
          w-full
          transition-all
          duration-500

          ${
            isScrolled
              ? "bg-green-800/95 shadow-lg backdrop-blur-md"
              : !isHomePage
              ? "bg-green-800"
              : "bg-transparent"
          }

          ${className}
        `}
      >
        {({ open }) => (
          <div className="mx-auto max-w-7xl">
            {/* =====================================================
                NAVBAR UTAMA
            ====================================================== */}

            <div className="relative flex h-16 items-center justify-between">
              {/* =====================================================
                  LOGO MOBILE
              ====================================================== */}

              <div className="absolute inset-y-0 left-3 flex items-center sm:hidden">
                <div className="flex flex-1 items-center justify-start gap-2 sm:hidden">
                  {/* Logo Diajeng */}
                  <div className="flex h-20 w-20 items-center justify-center overflow-hidden sm:h-24 sm:w-24 md:h-28 md:w-28">
                    <img
                      src={logoDiajeng}
                      alt="Logo Diajeng"
                      className="h-full w-full rounded-xl object-contain"
                      loading="lazy"
                    />
                  </div>

                  {/* Logo Kemenag */}
                  <div className="flex items-center">
                    <img
                      className="md:h-18 h-12 w-auto object-contain sm:h-12"
                      src={logokemenag}
                      alt="Logo Kemenag"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              {/* =====================================================
                  LOGO DESKTOP
              ====================================================== */}

              <div className="hidden flex-shrink-0 items-center gap-3 sm:flex">
                {/* Logo Diajeng */}
                <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-3xl sm:h-24 sm:w-24 md:h-28 md:w-28">
                  <img
                    src={logoDiajeng}
                    alt="Logo Diajeng"
                    className="h-full w-full object-contain"
                    loading="lazy"
                  />
                </div>

                {/* Logo Kemenag */}
                <div className="flex items-center">
                  <img
                    className="md:h-18 h-12 w-auto object-contain sm:h-12"
                    src={logokemenag}
                    alt="Logo Kemenag"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* =====================================================
                  MENU DESKTOP
              ====================================================== */}

              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-center">
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-1">
                    {updatedNavigation.map((item) => (
                      <div
                        className="group relative"
                        key={item.name}
                      >
                        {/* Menu Utama */}
                        <Link
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "rounded-lg bg-white/15 text-white"
                              : "rounded-lg text-green-100 hover:bg-white/10 hover:text-white",

                            "flex items-center px-3 py-2 text-sm font-medium transition-all duration-300"
                          )}
                          aria-current={
                            item.current ? "page" : undefined
                          }
                        >
                          {item.name}

                          {/* Icon dropdown hanya jika ada submenu */}
                          {item.submenu && (
                            <ChevronDownIcon className="ml-1 h-3.5 w-3.5 text-green-200 transition-transform duration-300 group-hover:rotate-180" />
                          )}
                        </Link>

                        {/* Submenu */}
                        {item.submenu && (
                          <div className="absolute left-0 top-full z-50 hidden pt-1 group-hover:block">
                            <div className="min-w-[180px] overflow-hidden rounded-xl border border-green-100 bg-white shadow-xl shadow-green-900/10">
                              {item.submenu.map((subItem) => (
                                <Link
                                  key={subItem.name}
                                  to={subItem.href}
                                  className="block px-4 py-2.5 text-sm text-gray-700 transition-colors duration-200 hover:bg-green-50 hover:text-green-700"
                                >
                                  {subItem.name}
                                </Link>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* =====================================================
                  BAGIAN KANAN NAVBAR
              ====================================================== */}

              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {/* =====================================================
                    HUBUNGI KAMI DESKTOP
                ====================================================== */}

                <Link
                  to="/kontak"
                  className="hidden items-center gap-2 rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-green-900/20 transition-all duration-300 hover:scale-105 hover:bg-green-700 hover:shadow-xl sm:flex"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />

                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>

                  Hubungi Kami
                </Link>

                {/* =====================================================
                    HAMBURGER MOBILE
                ====================================================== */}

                <DisclosureButton className="relative inline-flex items-center justify-center rounded-lg p-2 text-white transition-colors duration-300 hover:bg-white/10 sm:hidden">
                  <span className="sr-only">
                    Open main menu
                  </span>

                  {open ? (
                    <XMarkIcon
                      className="block h-7 w-7"
                      aria-hidden="true"
                    />
                  ) : (
                    <Bars3Icon
                      className="block h-7 w-7"
                      aria-hidden="true"
                    />
                  )}
                </DisclosureButton>
              </div>
            </div>

            {/* =====================================================
                MENU MOBILE
            ====================================================== */}

            <DisclosurePanel className="absolute inset-x-0 top-16 z-50 rounded-b-2xl border-t border-green-100 bg-white/95 shadow-xl backdrop-blur-md sm:hidden">
              <div className="flex flex-col space-y-1 p-3">
                {updatedNavigation.map((item) => (
                  <div
                    className="group relative"
                    key={item.name}
                  >
                    {/* Menu Utama Mobile */}
                    <Link
                      to={item.href}
                      className={classNames(
                        item.current
                          ? "rounded-lg bg-green-50 text-green-700"
                          : "rounded-lg text-gray-700 hover:bg-green-50 hover:text-green-700",

                        "flex items-center px-4 py-2.5 text-sm font-medium transition-colors duration-200"
                      )}
                      aria-current={
                        item.current ? "page" : undefined
                      }
                    >
                      {item.name}

                      {item.submenu && (
                        <ChevronDownIcon className="ml-1 h-4 w-4 text-gray-400" />
                      )}
                    </Link>

                    {/* Submenu Mobile */}
                    {item.submenu && (
                      <div className="absolute left-24 top-0 z-50 mt-0 hidden min-w-[160px] rounded-xl border border-green-100 bg-white shadow-xl group-hover:block">
                        {item.submenu.map((subItem) => (
                          <Link
                            key={subItem.name}
                            to={subItem.href}
                            className="block px-4 py-2.5 text-sm text-gray-600 transition-colors duration-200 hover:bg-green-50 hover:text-green-700"
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                {/* =====================================================
                    HUBUNGI KAMI MOBILE
                ====================================================== */}

                <div className="border-t border-gray-100 pt-2">
                  <Link
                    to="/kontak"
                    className="mx-2 flex items-center justify-center gap-2 rounded-lg bg-green-600 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-green-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />

                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>

                    Hubungi Kami
                  </Link>
                </div>
              </div>
            </DisclosurePanel>
          </div>
        )}
      </Disclosure>
    </div>
  );
}